export default __webpack_public_path__ + "images/4efc08d6f3224e582139fbb389c9867a-andy-greeting.en.png";